import {GetHealthSpecialtiesLocalitiesParams} from 'domain/usecases';
import {makeGetHealthSpecialtiesLocalities} from 'main/factories/usecases';
import {categorizeSpecialtiesByFirstLetter, sortByKey, Specialty} from 'presentation/utils';
import {FlowEnum} from '../../constants/flowEnum';
import {GetHealthSpecialtiesLocalitiesParams as GetHealthSpecialtiesLocalitiesParamsV1} from 'domain/usecases/private/booking-flow/health-V1';
import {makeGetHealthSpecialtiesLocalities as makeGetHealthSpecialtiesLocalitiesV1} from 'main/factories/usecases/private/booking-flow/remote-health-booking-v1';

async function getHealthSpecialties(params: GetHealthSpecialtiesLocalitiesParams) {
	const response = await makeGetHealthSpecialtiesLocalities().get(params);

	if (!response) return [];

	const specialties = response.especialidades;
	const parsedSpecialties: Specialty<FlowEnum.HEALTH>[] = specialties.flatMap(specialty => {
		if (specialty.subEspecialidades.length === 0) {
			return {
				code: specialty.cdEspecialidade.toString(),
				description: specialty.dsEspecialidade,
				telemedicine: specialty.telemedicina,
				formattedText: specialty.dsEspecialidade,
				multipleBookings: specialty.flExecutaSessao,
				hasDefinition: specialty.flTemDefinicao,
			};
		}
		return specialty.subEspecialidades.map(sub => ({
			code: specialty.cdEspecialidade.toString(),
			description: specialty.dsEspecialidade,
			sub_code: sub.cdSubEspecialidade.toString(),
			sub_description: sub.dsSubEspecialidade,
			telemedicine: specialty.telemedicina,
			formattedText: `${specialty.dsEspecialidade} - ${sub.dsSubEspecialidade}`,
			multipleBookings: specialty.flExecutaSessao,
			hasDefinition: specialty.flTemDefinicao,
		}));
	});

	const sortedSpecialtiesByName =
		parsedSpecialties && sortByKey(parsedSpecialties, 'formattedText');
	const categorizedSpecialties =
		sortedSpecialtiesByName && categorizeSpecialtiesByFirstLetter(sortedSpecialtiesByName);

	return categorizedSpecialties;
}

async function getHealthSpecialtiesV1(params: GetHealthSpecialtiesLocalitiesParamsV1) {
	const response = await makeGetHealthSpecialtiesLocalitiesV1().get(params);

	if (!response) {
		return [];
	}

	const specialties = response.especialidades;
	const parsedSpecialties: Specialty<FlowEnum.HEALTH>[] = specialties.flatMap(specialty => {
		if (specialty.subEspecialidades.length === 0) {
			return {
				code: specialty.cdEspecialidade.toString(),
				description: specialty.dsEspecialidade,
				telemedicine: specialty.telemedicina,
				formattedText: specialty.dsEspecialidade,
				multipleBookings: specialty.flExecutaSessao,
				hasDefinition: specialty.flTemDefinicao,
			};
		}
		return specialty.subEspecialidades.map(sub => ({
			code: specialty.cdEspecialidade.toString(),
			description: specialty.dsEspecialidade,
			sub_code: sub.cdSubEspecialidade.toString(),
			sub_description: sub.dsSubEspecialidade,
			telemedicine: specialty.telemedicina,
			formattedText: `${specialty.dsEspecialidade} - ${sub.dsSubEspecialidade}`,
			multipleBookings: specialty.flExecutaSessao,
			hasDefinition: specialty.flTemDefinicao,
		}));
	});
	const sortedSpecialtiesByName =
		parsedSpecialties && sortByKey(parsedSpecialties, 'formattedText');
	const categorizedSpecialties =
		sortedSpecialtiesByName && categorizeSpecialtiesByFirstLetter(sortedSpecialtiesByName);

	return categorizedSpecialties;
}

export {getHealthSpecialties, getHealthSpecialtiesV1};
